import {Injectable} from '@angular/core';
import {LocalStorageService} from './main/local-storage.service';
import {Beneficiaire} from '../../models/beneficiaire/beneficiaire.model';
import {STORAGE_KEY_BENEFICIAIRE} from './constant-key';

@Injectable()
export class BeneficiaireStorageService {

    public constructor(private storage: LocalStorageService) {
    }

    /**
     * @param {Beneficiaire} beneficiaire
     */
    public set(beneficiaire: Beneficiaire): void {
        this.storage.set(STORAGE_KEY_BENEFICIAIRE, beneficiaire);
    }

    /**
     * @returns {Beneficiaire}
     */
    public get(): Beneficiaire {
        return this.storage.get(STORAGE_KEY_BENEFICIAIRE) as Beneficiaire;
    }

    public remove(): void {
        this.storage.remove(STORAGE_KEY_BENEFICIAIRE);
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/storage/beneficiaire-storage.service.ts